import React from "react";
import { Link } from "react-router-dom";
import SuceesfulGraphic from "../assets/images/SuceesfulGraphic.svg";
import { Button, Logo } from "./ui";
import {
  GO_TO_MEETINGS,
  PAYMENT_RECEIVED,
  PAYMENT_RECEIVED_BODY,
} from "./plan/planCopy";

// /confirm-payment — Pooled inbox SP5 (spec § Removals): the landing after a
// meeting add-on payment, and nothing else. A plan start lands on
// /plan/started; Plaid is gone from here (it needs no plan, owner item 15,
// and lives in the questions and the dashboard).
const PaymentSuccess = () => (
  <div className="stars-dark tw-min-h-screen tw-bg-bg tw-font-sans tw-text-text">
    <main className="tw-mx-auto tw-w-full tw-max-w-lg tw-px-4 tw-pb-12 tw-pt-6 md:tw-pt-8">
      <Logo alt="" className="tw-w-36" />
      <div className="tw-grid tw-justify-items-center tw-gap-4 tw-pt-12 tw-text-center">
        <img src={SuceesfulGraphic} alt="" className="tw-h-auto tw-w-40" />
        <h1 className="tw-m-0 tw-mt-4 tw-text-2xl tw-font-bold tw-text-text">
          {PAYMENT_RECEIVED}
        </h1>
        <p className="tw-m-0 tw-text-md tw-text-text-muted">
          {PAYMENT_RECEIVED_BODY}
        </p>
        <Button as={Link} variant="text" to="/meetings">
          {GO_TO_MEETINGS}
        </Button>
      </div>
    </main>
  </div>
);

export default PaymentSuccess;
